import axios from "axios";

export default class JobOrdersDetailsCommand {
    joborderdetails : any

    constructor()
    {
     this.joborderdetails=null;
    }


    async loadJobOrderDetail(jobid:any, ksorderid:any) {
        try {
          const API_URL = process.env.REACT_APP_API_URL;
          const idToken: string | null = localStorage.getItem("IdToken");
          const response = await axios.get(
            `${API_URL}/v1/jobs/${jobid}/joborders/${ksorderid}/details`,
            {
              headers: {
                Authorization: `${idToken}`,
              },
            }
          );
    
          const data = response.data.response; // Assumes server returns a single item
          this.joborderdetails = data;
        } catch (error) {
          console.error("Failed to load orders details data:", error);
        }
      }
}